import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";
import { CategoriePa, EtatDocumentPa } from "./document-pa.entity";

export class StepDefinitionPaEntity {
	
	id!: number;
	dateDebut!: number[] | LocalDate | null;
	dateFin!: number[] | LocalDate | null;
	duree!: number;
	horaires!: string;
	nombreIntervenants!: number;
	description!: string;
	etat!: EtatDocumentPa;

	numeroPa!: string;
	commune!: string;
	parcIds: number[] = [];
	responsableId!: number;
	lastCompletedStep!: number;
	categoriePa!: CategoriePa;
}
